import invoker from "./invoker";

// Date -> Number
const unixFromDate = invoker(0, "unix");

export default unixFromDate;
